import { FiChevronRight } from "react-icons/fi";
import styled from "styled-components/macro";
import { Link, Card } from "../common";

export const CardIcon = styled(FiChevronRight)`
  font-size: 2rem;
  color: ${({ theme }) => theme.color.brandPrimary.light};
`;

export const BodyLabelLink = styled.span`
  color: ${({ theme }) => theme.color.brandPrimary.light};
  margin-bottom: 4px;
`;

export const Description = styled.span`
  color: ${({ theme }) => theme.color.neutral["03"]};
`;

export const NavigationLinkItemStyled = styled(Link)`
  width: 100%;
  height: 100%;
  text-decoration: none !important;
`;

export const NavigationCardItemStyled = styled(Card)`
  border-bottom: 1px solid ${({ theme }) => theme.color.brandPrimary.light};
  margin-bottom: 16px;
  & .Card__Body {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  & .Card__Body > div {
    width: 100%;
    max-width: 90%;
  }
`;

export const ListLinks = styled.ul({});

export const ContentNavigation = styled.div({
  ".DoubleContent__ContentColumn": {
    padding: "0 !important",
  },
});
